import { FaLeaf, FaWind, FaLungs, FaPills } from "react-icons/fa6";


export const proProgramsData = [
    {
        id: 1,
        title: "Technician Salaries & Equipment Covered",
        description:
            "MITSI covers trained technician salaries and essential neurofeedback equipment at no extra cost.",
    },
    {
        id: 2,
        title: "No Upfront Costs for Neurofeedback",
        description:
            "Start your neurofeedback program with no upfront costs or hidden fees through MITSI's reimbursement program.",
    },
    {
        id: 3,
        title: "Flexible Billing & Payment Support",
        description:
            "Simplify neurofeedback billing with optional support and direct payments for confirmed sessions.",
    },
    {
        id: 4,
        title: "Personalized Immunotherapy for Allergy Relief",
        description:
            "Personalized immunotherapy helps reduce allergy symptoms and provides long-term relief.",
    },
];



export const benefitsData = [
    {
        title: "Chronic Allergies",
        description:
            "People with persistent allergies may find relief. OTC medicines don't help much.",
        icon: FaLeaf,
    },
    {
        title: "Environmental Allergies",
        description:
            "Immunotherapy targets common triggers, like pollen, dust, animal dander, and mold. It is effective.",
        icon: FaWind,
    },
    {
        title: "Allergic Asthma",
        description:
            "Immunotherapy may help people with allergic asthma. It can reduce asthma flare-ups caused by allergens.",
        icon: FaLungs,
    },
    {
        title: "Limited Medication Tolerance",
        description:
            "Some people cannot tolerate allergy medications. Others prefer natural options, and they can benefit from this long-term solution.",
        icon: FaPills,
    },
];